import { Links, LoaderFunctionArgs, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData } from "react-router";
import mainStyles from "./styles/base/main.css?url";

export const links = () => [
  { rel: "stylesheet", href: mainStyles },
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const nodeEnv = process.env.NODE_ENV || 'development';
  const appEnv = process.env.APP_ENV || 'development';
  const isProduction = appEnv === 'production';
  const gaMeasurementId = process.env.GA_MEASUREMENT_ID || null;
  const analyticsApiToken = process.env.ANALYTICS_API_TOKEN || 'dev-token-change-in-production';

  // Debug logging to verify environment variables
  if(nodeEnv === 'development') {
    console.log('🔧 Server Environment:', {
      NODE_ENV: nodeEnv,
      APP_ENV: appEnv,
      IS_PRODUCTION: isProduction,
      GA_MEASUREMENT_ID: gaMeasurementId ? `${gaMeasurementId.substring(0, 5)}...` : 'NOT SET',
    });
  }

  return {
    env: {
      NODE_ENV: nodeEnv,
      GA_MEASUREMENT_ID: gaMeasurementId,
      ANALYTICS_API_TOKEN: analyticsApiToken,
      IS_PRODUCTION: isProduction,
      SENTRY_DSN: isProduction ? process.env.SENTRY_DSN || null : null,
      APP_ENV: appEnv,
    },
  };
};

export default function App() {
  const { env } = useLoaderData<typeof loader>();
  const gaMeasurementId = env.GA_MEASUREMENT_ID;

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />

        {/* Expose environment variables to client */}
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(env)};`,
          }}
        />

        {/* Google Analytics */}
        {gaMeasurementId && (
          <>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`} />
            <script
              dangerouslySetInnerHTML={{
                __html: `
                  console.log('[GA Root] Initializing with ID:', '${gaMeasurementId}');
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){window.dataLayer.push(arguments);}
                  window.gtag = gtag;
                  gtag('js', new Date());
                  gtag('config', '${gaMeasurementId}', {
                    page_path: window.location.pathname,
                    send_page_view: false,
                    debug_mode: ${env.NODE_ENV === 'development'}
                  });
                  console.log('[GA Root] gtag initialized, type:', typeof window.gtag);
                `,
              }}
            />
          </>
        )}

        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
